<template>
  <div class="headline">
    <span :class="headlineClass">{{ content.title }}</span>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';
import { Content } from '@forchange/storytime';

const headlineLevelClasses: Record<number, string> = {
  1: 'text-2xl',
  2: 'headline-level-2',
  3: 'text-xl'
};

@Component
export default class Headline extends Vue {
  @Prop({ type: Object }) content!: Content & { title: string; level: number };
  @Prop({ type: IntersectionObserver }) observer!: IntersectionObserver;

  get headlineClass() {
    const level = Math.min(Math.max(Number(this.content?.level) || 1, 1), 3);
    return ['headline-span', headlineLevelClasses[level]];
  }

  mounted() {
    if (window.storyteller.topContet?.$kind === 'Headline') {
      window.next();
    }
  }
}
</script>

<style scoped>
.headline {
  @apply relative text-left mx-2 py-4 md:ml-12;
}
.headline-span {
  @apply text-black;
}
.headline-level-2 {
  font-size: 1.35rem;
}
</style>
